import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { formatMoneyCents } from "@/core/utils/money";
import type { StAdjustmentTechnicianGroup } from "@/payroll/pay-breakdown/st-adjustments/types";
import { isPushableGroup } from "@/payroll/pay-breakdown/st-adjustments/utils";

// The money about to move, so the pending amount leads. The period total sits
// under it only when the two differ — otherwise it's the same number twice.
export const AMOUNT_COLUMN: ColumnDef<StAdjustmentTechnicianGroup, unknown> = {
  id: "amount",
  header: "Pending amount",
  enableSorting: false,
  meta: { size: "12rem" },
  cell: ({ row }) => {
    const group = row.original;
    const pushable = isPushableGroup(group);
    const leadCents = pushable
      ? group.pending_amount_cents
      : group.amount_cents;
    const showsTotal =
      pushable && group.pending_amount_cents !== group.amount_cents;

    return (
      <Stack className="w-full" align="start" gap={0}>
        <Text className="tabular-nums">
          {formatMoneyCents(leadCents) ?? "$0"}
        </Text>
        {showsTotal && (
          <Text className="tabular-nums" tone="muted">
            of {formatMoneyCents(group.amount_cents) ?? "$0"}
          </Text>
        )}
      </Stack>
    );
  },
};
